<h1 mat-dialog-title>{{'Dialogs.Form.ConfirmAddress.Title' | translate}}</h1>
<div mat-dialog-content>
  <p>{{'Dialogs.Form.ConfirmAddress.Explanation' | translate}}</p>
  <form>
    <div *ngIf="locale === 'pt-BR'">
      <mat-form-field style="width: 100%;">
        <mat-label>{{'Dialogs.Form.ConfirmAddress.Street' | translate }}</mat-label>
        <input type="text" autocomplete="off" matInput [(ngModel)]="street" name="street">
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{'Dialogs.Form.ConfirmAddress.Number' | translate }}</mat-label>
        <input type="text" autocomplete="off" matInput [(ngModel)]="placenumber" name="placenumber">
      </mat-form-field>
      <div style="width: 10px;"></div>
      <mat-form-field>
        <mat-label>{{'Dialogs.Form.ConfirmAddress.Neighbourhood' | translate }}</mat-label>
        <input type="text" autocomplete="off" matInput [(ngModel)]="neighboubourhood" name="neighboubourhood">
      </mat-form-field>
      <div style="width: 10px;"></div>
      <mat-form-field>
        <mat-label>{{'Dialogs.Form.ConfirmAddress.ZipCode' | translate }}</mat-label>
        <input type="text" autocomplete="off" matInput [(ngModel)]="zipcode" name="zipcode">
      </mat-form-field>
    </div>
    <div *ngIf="locale === 'en-IE'">
      <mat-form-field style="width: 100%;">
        <mat-label>{{'Dialogs.Form.ConfirmAddress.Address' | translate }}</mat-label>
        <input type="text" autocomplete="off" matInput [(ngModel)]="addressString" name="addressString">
      </mat-form-field>
    </div>
  </form>
</div>
<div mat-dialog-actions>
  <div class="filler"></div>
  <button mat-button (click)="onCancel()">{{'Dialogs.Form.ConfirmAddress.Cancel' | translate}}</button>
  <button mat-button (click)="onConfirm()" cdkFocusInitial>{{'Dialogs.Form.ConfirmAddress.Accept' | translate}}</button>
</div>